// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2318508d","488":"b1867c0e","977":"d26a557d"}[chunkId] + ".chunk.js";
};